<template>
  <v-layout row wrap align-start>
    <v-flex lg12>
      <v-layout row wrap>
        <v-flex xs6 px-1 py-1>
          <SimpleTextAreaInput
            @input="changeDriverNotes"
            v-model="bookingForm.booking.message"
            label="Driver Notes"
          />
        </v-flex>
        <v-flex
          :xs6="bookingForm.booking.state == null || bookingForm.booking.state != 'completed'"
          :xs12="bookingForm.booking.state == 'completed'"
          :py-2="bookingForm.booking.state == 'completed'"
          px-1
          py-1
        >
          <SimpleTextAreaInput
            @input="changeInternalNotes"
            v-model="bookingForm.booking.notes"
            :maxlength="5000"
            label="Internal Notes"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "UserNotes",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    SimpleTextAreaInput
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    hideCustomer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      bookingMessages: []
    };
  },
  computed: {
    bookingIsNotBooked() {
      return this.bookingForm.booking.state == null;
    },
    bookingIsCancelled() {
      return this.bookingForm.booking.state == "cancelled";
    },
    bookingIsCompletedOrCancelled() {
      return (
        this.bookingForm.booking.state == "completed" ||
        this.bookingForm.booking.state == "cancelled"
      );
    }
  },
  mounted: function() {
    this.get();
  },
  methods: {
    updateNotes() {
      this.$emit("updateNotes", null);
    },
    changeLockedOut(lockOut) {},
    changeUserNotes: function(notes) {
      this.bookingForm.user.notes = notes;
    },
    changeDriverNotes: function(notes) {
      this.bookingForm.booking.message = notes;
    },
    changeInternalNotes: function(notes) {
      this.bookingForm.booking.notes = notes;
    },
    get: function(p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/predefined_messages/all`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.bookingMessages = res.data.booking_messages;
          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    copyToClipboard: function(val) {
      const el = document.createElement("textarea");
      el.value = val;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      console.log(val);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled-panel {
  pointer-events: none;
}

.change-cost-panel {
  padding: 8px 0px;
  background-color: #e3f2fd;
}
</style>
